import { Swiper, SwiperSlide } from "swiper/react";
import React from "react";
import "swiper/css"; // Import Swiper styles
import "swiper/css/navigation"; // Optional: for navigation buttons
import "swiper/css/pagination";
import evelu from "../../../assets/images/evelu.svg";
import Avatar00 from "../../../assets/images/Avatar00.webp";
import start_rating from "../../../assets/images/start_rating.webp";

export default function Evaluate() {
  return (
    <div className="w-full relative bg-[#f8ffff] lg:px-[120px] py-[40px]">
      <div className="container mx-auto p-3 relative">
        <div className="flex flex-col gap-3 relative">
          <p className="text-[28px] text-[#033F6A] font-semibold lg:text-[36px]">
            Đánh giá từ đối tác và khách hàng
          </p>
          <div className="border border-[#27C6FF] w-[7.125rem] h-10 rounded-[40px] lg:hidden bg-[#27C6FF] flex items-center justify-center">
            <p className="text-[16px] font-semibold text-white">BlueSkyIT</p>
          </div>
          <p className="text-[16px] font-normal text-[#1F1F1F]">
            Chúng tôi luôn nhận được sự tin tưởng và đánh giá cao từ các đối tác
            và khách hàng. Đây là động lực giúp BlueskyIT không ngừng phát
            triển.
          </p>
        </div>

        <div className="w-full lg:pt-4 relative">
          <div className="block lg:hidden mt-14 ">
            <Swiper spaceBetween={20} slidesPerView={1} className="mySwiper">
              <SwiperSlide>
                <div className="border border-solid relative shadow-custom border-[#F1F0F0] bg-white w-full rounded-[30px] h-[281px] ">
                  <div className="border border-[#1C9BDB] left-[25px] py-3 absolute top-[-15px] z-30 bg-[#1C9BDB] flex items-center justify-center rounded-full w-[42px] h-[42px]">
                    <img src={evelu} alt="eve" />
                  </div>
                  <div className="mt-10 px-5 py-3">
                    <img src={start_rating} alt="st" className="w-[120px]" />
                  </div>
                  <div className="w-full px-5 py-3">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      In ac congue elit. Pellentesque quis feugiat ex.
                      Pellentesque ac elit at quam porttitor mollis.
                    </p>
                  </div>
                  <div className="w-full border border-b-gray-200"></div>
                  <div className="flex flex-row items-center gap-2 px-5 py-3 w-full">
                    <div>
                      <img
                        src={Avatar00}
                        alt="aa"
                        className="w-[50px] h-[50px] object-cover"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <p className="text-[16px] font-semibold text-[#333333]">
                        Phạm Ngọc Linh
                      </p>
                      <p className="text-[14px] text-[#919191] font-normal">
                        CEO Minh Phú
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="border border-solid relative shadow-custom border-[#F1F0F0] bg-white w-full rounded-[30px] h-[281px] ">
                  <div className="border border-[#1C9BDB] left-[25px] py-3 absolute top-[-15px] z-30 bg-[#1C9BDB] flex items-center justify-center rounded-full w-[42px] h-[42px]">
                    <img src={evelu} alt="eve" />
                  </div>
                  <div className="mt-10 px-5 py-3">
                    <img src={start_rating} alt="st" className="w-[120px]" />
                  </div>
                  <div className="w-full px-5 py-3">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      In ac congue elit. Pellentesque quis feugiat ex.
                      Pellentesque ac elit at quam porttitor mollis.
                    </p>
                  </div>
                  <div className="w-full border border-b-gray-200"></div>
                  <div className="flex flex-row items-center gap-2 px-5 py-3 w-full">
                    <div>
                      <img
                        src={Avatar00}
                        alt="aa"
                        className="w-[50px] h-[50px] object-cover"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <p className="text-[16px] font-semibold text-[#333333]">
                        Phạm Ngọc Linh
                      </p>
                      <p className="text-[14px] text-[#919191] font-normal">
                        CEO Minh Phú
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="border border-solid relative shadow-custom border-[#F1F0F0] bg-white w-full rounded-[30px] h-[281px] ">
                  <div className="border border-[#1C9BDB] left-[25px] py-3 absolute top-[-15px] z-30 bg-[#1C9BDB] flex items-center justify-center rounded-full w-[42px] h-[42px]">
                    <img src={evelu} alt="eve" />
                  </div>
                  <div className="mt-10 px-5 py-3">
                    <img src={start_rating} alt="st" className="w-[120px]" />
                  </div>
                  <div className="w-full px-5 py-3">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      In ac congue elit. Pellentesque quis feugiat ex.
                      Pellentesque ac elit at quam porttitor mollis.
                    </p>
                  </div>
                  <div className="w-full border border-b-gray-200"></div>
                  <div className="flex flex-row items-center gap-2 px-5 py-3 w-full">
                    <div>
                      <img
                        src={Avatar00}
                        alt="aa"
                        className="w-[50px] h-[50px] object-cover"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <p className="text-[16px] font-semibold text-[#333333]">
                        Phạm Ngọc Linh
                      </p>
                      <p className="text-[14px] text-[#919191] font-normal">
                        CEO Minh Phú
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="border border-solid relative shadow-custom border-[#F1F0F0] bg-white w-full rounded-[30px] h-[281px] ">
                  <div className="border border-[#1C9BDB] left-[25px] py-3 absolute top-[-15px] z-30 bg-[#1C9BDB] flex items-center justify-center rounded-full w-[42px] h-[42px]">
                    <img src={evelu} alt="eve" />
                  </div>
                  <div className="mt-10 px-5 py-3">
                    <img src={start_rating} alt="st" className="w-[120px]" />
                  </div>
                  <div className="w-full px-5 py-3">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      In ac congue elit. Pellentesque quis feugiat ex.
                      Pellentesque ac elit at quam porttitor mollis.
                    </p>
                  </div>
                  <div className="w-full border border-b-gray-200"></div>
                  <div className="flex flex-row items-center gap-2 px-5 py-3 w-full">
                    <div>
                      <img
                        src={Avatar00}
                        alt="aa"
                        className="w-[50px] h-[50px] object-cover"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <p className="text-[16px] font-semibold text-[#333333]">
                        Phạm Ngọc Linh
                      </p>
                      <p className="text-[14px] text-[#919191] font-normal">
                        CEO Minh Phú
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
          <div className="hidden lg:block">
            <Swiper
              spaceBetween={20}
              slidesPerView={3}
              breakpoints={{
                sm: {
                  slidesPerView: 7,
                },
                lg: {
                  slidesPerView: 10,
                },
              }}
              className="mySwiper"
            >
              <SwiperSlide>
                <div className="border border-solid relative shadow-custom border-[#F1F0F0] bg-white w-full rounded-[30px] h-[281px] lg:h-[300px] ">
                  <div className="border border-[#1C9BDB] left-[25px] py-3 absolute top-[-15px] z-30 bg-[#1C9BDB] flex items-center justify-center rounded-full w-[42px] h-[42px]">
                    <img src={evelu} alt="eve" />
                  </div>
                  <div className="mt-10 px-5 py-3">
                    <img src={start_rating} alt="st" className="w-[120px]" />
                  </div>
                  <div className="w-full px-5 py-3">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      In ac congue elit. Pellentesque quis feugiat ex.
                      Pellentesque ac elit at quam porttitor mollis.
                    </p>
                  </div>
                  <div className="w-full border border-b-gray-200"></div>
                  <div className="flex flex-row items-center gap-2 px-5 py-3 w-full">
                    <div>
                      <img
                        src={Avatar00}
                        alt="aa"
                        className="w-[50px] h-[50px] object-cover"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <p className="text-[16px] font-semibold text-[#333333]">
                        Phạm Ngọc Linh
                      </p>
                      <p className="text-[14px] text-[#919191] font-normal">
                        CEO Minh Phú
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="border border-solid relative shadow-custom border-[#F1F0F0] bg-white w-full rounded-[30px] h-[281px] lg:h-[300px] ">
                  <div className="border border-[#1C9BDB] left-[25px] py-3 absolute top-[-15px] z-30 bg-[#1C9BDB] flex items-center justify-center rounded-full w-[42px] h-[42px]">
                    <img src={evelu} alt="eve" />
                  </div>
                  <div className="mt-10 px-5 py-3">
                    <img src={start_rating} alt="st" className="w-[120px]" />
                  </div>
                  <div className="w-full px-5 py-3">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      In ac congue elit. Pellentesque quis feugiat ex.
                      Pellentesque ac elit at quam porttitor mollis.
                    </p>
                  </div>
                  <div className="w-full border border-b-gray-200"></div>
                  <div className="flex flex-row items-center gap-2 px-5 py-3 w-full">
                    <div>
                      <img
                        src={Avatar00}
                        alt="aa"
                        className="w-[50px] h-[50px] object-cover"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <p className="text-[16px] font-semibold text-[#333333]">
                        Phạm Ngọc Linh
                      </p>
                      <p className="text-[14px] text-[#919191] font-normal">
                        CEO Minh Phú
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="border border-solid relative shadow-custom border-[#F1F0F0] bg-white w-full rounded-[30px] h-[281px] lg:h-[300px] ">
                  <div className="border border-[#1C9BDB] left-[25px] py-3 absolute top-[-15px] z-30 bg-[#1C9BDB] flex items-center justify-center rounded-full w-[42px] h-[42px]">
                    <img src={evelu} alt="eve" />
                  </div>
                  <div className="mt-10 px-5 py-3">
                    <img src={start_rating} alt="st" className="w-[120px]" />
                  </div>
                  <div className="w-full px-5 py-3">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      In ac congue elit. Pellentesque quis feugiat ex.
                      Pellentesque ac elit at quam porttitor mollis.
                    </p>
                  </div>
                  <div className="w-full border border-b-gray-200"></div>
                  <div className="flex flex-row items-center gap-2 px-5 py-3 w-full">
                    <div>
                      <img
                        src={Avatar00}
                        alt="aa"
                        className="w-[50px] h-[50px] object-cover"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <p className="text-[16px] font-semibold text-[#333333]">
                        Phạm Ngọc Linh
                      </p>
                      <p className="text-[14px] text-[#919191] font-normal">
                        CEO Minh Phú
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="border border-solid relative shadow-custom border-[#F1F0F0] bg-white w-full rounded-[30px] h-[281px] lg:h-[300px]">
                  <div className="border border-[#1C9BDB] left-[25px] py-3 absolute top-[-15px] z-30 bg-[#1C9BDB] flex items-center justify-center rounded-full w-[42px] h-[42px]">
                    <img src={evelu} alt="eve" />
                  </div>
                  <div className="mt-10 px-5 py-3">
                    <img src={start_rating} alt="st" className="w-[120px]" />
                  </div>
                  <div className="w-full px-5 py-3">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      In ac congue elit. Pellentesque quis feugiat ex.
                      Pellentesque ac elit at quam porttitor mollis.
                    </p>
                  </div>
                  <div className="w-full border border-b-gray-200"></div>
                  <div className="flex flex-row items-center gap-2 px-5 py-3 w-full">
                    <div>
                      <img
                        src={Avatar00}
                        alt="aa"
                        className="w-[50px] h-[50px] object-cover"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <p className="text-[16px] font-semibold text-[#333333]">
                        Phạm Ngọc Linh
                      </p>
                      <p className="text-[14px] text-[#919191] font-normal">
                        CEO Minh Phú
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="border border-solid relative shadow-custom border-[#F1F0F0] bg-white w-full rounded-[30px] h-[281px] lg:h-[300px] ">
                  <div className="border border-[#1C9BDB] left-[25px] py-3 absolute top-[-15px] z-30 bg-[#1C9BDB] flex items-center justify-center rounded-full w-[42px] h-[42px]">
                    <img src={evelu} alt="eve" />
                  </div>
                  <div className="mt-10 px-5 py-3">
                    <img src={start_rating} alt="st" className="w-[120px]" />
                  </div>
                  <div className="w-full px-5 py-3">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      In ac congue elit. Pellentesque quis feugiat ex.
                      Pellentesque ac elit at quam porttitor mollis.
                    </p>
                  </div>
                  <div className="w-full border border-b-gray-200"></div>
                  <div className="flex flex-row items-center gap-2 px-5 py-3 w-full">
                    <div>
                      <img
                        src={Avatar00}
                        alt="aa"
                        className="w-[50px] h-[50px] object-cover"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <p className="text-[16px] font-semibold text-[#333333]">
                        Phạm Ngọc Linh
                      </p>
                      <p className="text-[14px] text-[#919191] font-normal">
                        CEO Minh Phú
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
}
